<h3 mat-dialog-title class="aza-pa-dialog-title">{{data?.dialogTitle}}</h3>
<div mat-dialog-content class="aza-pa-dialog-content">
  <ng-container *ngTemplateOutlet="data?.template; context: context"></ng-container>
</div>
<div mat-dialog-actions class="aza-pa-dialog-actions">
  @if (data?.hasCancelButton) {
    <azavista-button action="cancel" (click)="onClose()" class="aza-pa-dialog-action-cancel-button">
      <span translate>CANCEL</span>
    </azavista-button>
  }
  @if (data?.extraButtons) {
    @for (extraBtn of data?.extraButtons; track extraBtn) {
      <azavista-button action="extra-button-{{ extraBtn.id }}" (click)="onExtraBtnClicked(extraBtn)" class="aza-pa-dialog-action-extra-button">
        <span>{{ extraBtn.label | uppercase }}</span>
      </azavista-button>
    }
  }
  <azavista-button action="apply" (click)="onApply()" color="primary" class="aza-pa-dialog-action-apply-button">
    <span>{{ applyBtnLabel | uppercase }}</span>
  </azavista-button>
</div>
